module.exports = __webpack_public_path__ + "fc47e210170b219a9a9aeb212a98f6b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/e/e28.jpg
// module id = 560
// module chunks = 0